import { derived } from 'overmind';
import {
  ContentType,
  MediaType,
  FavoriteItem,
} from '#types/generated/graphql-types';

const GROUPED_FAVORITES_ORDER = {
  movies: 1,
  series: 2,
  podcasts: 3,
  Episodes: 4,
  podcastEpisodes: 5,
};

type GroupedFavorites = {
  [key: string]: ItemGroup;
};

type ItemGroup = {
  title: string;
  items: FavoriteItem[];
};

type State = {
  loading: boolean;
  items: FavoriteItem[];
  itemsIri: string[];
  groupedItems: ItemGroup[];
};

export type FavouriteCreateInput = { iri: string };

export const state: State = {
  loading: true,
  items: [],
  itemsIri: derived((_state: State) => {
    return _state.items.map((item) => item.iri);
  }),
  groupedItems: derived((_state: State) => {
    const groupedFavorites: GroupedFavorites = {
      episodes: { title: 'Episodes', items: [] },
      podcastEpisodes: { title: 'podcastEpisodes', items: [] },
      movies: { title: 'movies', items: [] },
      series: { title: 'series', items: [] },
      podcasts: { title: 'podcasts', items: [] },
      livestreams: { title: 'livestreams', items: [] },
    };

    _state.items.forEach((item) => {
      const currentItem = item;

      const isAudio =
        item.contentType === ContentType.Audio &&
        item.mediaType === MediaType.Standalone &&
        item.isMediaLive === true;
      const isLivestream =
        item.contentType === ContentType.LiveStream &&
        item.isMediaLive === true;
      const isMovie =
        item.contentType === ContentType.Video &&
        item.mediaType === MediaType.Standalone &&
        item.isMediaLive === true;
      const isEpisode =
        item.contentType === ContentType.Video &&
        item.mediaType === MediaType.Episode &&
        item.isMediaLive === true;
      const isPodcastEpisode =
        item.contentType === ContentType.Audio &&
        item.mediaType === MediaType.Episode &&
        item.isMediaLive === true;
      const isSeries =
        item.contentType === 'Series' &&
        item.isMediaLive === true;

      if (isEpisode) {
        groupedFavorites.episodes.items.unshift(currentItem);
      }

      if (isPodcastEpisode) {
        groupedFavorites.podcastEpisodes.items.unshift(currentItem);
      }

      if (isAudio) {
        groupedFavorites.podcasts.items.unshift(currentItem);
      }

      if (isLivestream) {
        groupedFavorites.livestreams.items.unshift(currentItem);
      }

      if (isMovie) {
        groupedFavorites.movies.items.unshift(currentItem);
      }

      if (isSeries) {
        groupedFavorites.series.items.unshift(currentItem);
      }
    });

    return Object.values(groupedFavorites)
      .filter((fav) => fav.items.length > 0)
      .sort((a, b) =>
        GROUPED_FAVORITES_ORDER[a.title] > GROUPED_FAVORITES_ORDER[b.title]
          ? 1
          : -1
      );
  }),
};
